var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationSucess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.683,
    height: 164,
    viewBox: "0 0 168.683 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebf5f8;}.b{fill:#263238;}.c{fill:#e0e0e0;}.d{fill:#455a64;}.e{fill:#ffbe9d;}.f{fill:#206799;}.g{opacity:0.6;}.h{fill:#fff;}.i{fill:#eb996e;}.j{fill:#0899ba;}.k{fill:#107891;}.l{opacity:0.3;}.m{fill:#4fc66a;}.n{fill:#ebb500;}.o{fill:#c09401;}.p{opacity:0.82;}.q{fill:#3b6884;}.r{fill:#337ead;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-547.195 -172.024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.907 172.024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.123,64.08l-.708-1.17A30.951,30.951,0,0,0,159.2,47.823a29.385,29.385,0,0,0-4.367.6A32.454,32.454,0,0,0,131.69,68.534c-2.2,5.909-2.818,12.712-6.992,17.4-5.435,6.106-14.662,6.3-22.772,6.06s-17.344-.034-22.753,6.091c-3.386,3.841-4.462,9.3-4.189,14.435.723,13.609,10.2,25.776,22.264,31.817s26.253,6.579,39.457,3.917c18.488-3.727,36.071-13.962,46.638-29.768S196.581,81.14,188.123,64.08Z",
    transform: "translate(-74.943 -47.764)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.875,
    cy: 11.875,
    r: 11.875,
    transform: "translate(6.661 18.839) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 163.072)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M199.121,478.388c0,.053-35.6.1-79.482.1s-79.489-.045-79.489-.1,35.582-.1,79.489-.1S199.121,478.332,199.121,478.388Z",
    transform: "translate(-40.15 -478.29)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.366 63.993)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M239.233,351.87l15.617,47.983H252L233.71,351.87Z",
    transform: "translate(-192.761 -300.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.183,351.758h-1.439l-4.1.023.038-.057c3.136,8.17,9.9,25.84,17.73,46.294.212.561.424,1.136.636,1.67l-.091-.061H254.8l-.095.129c-4.36-13.45-8.25-25.438-11.049-34.067-1.394-4.322-2.515-7.8-3.288-10.2-.379-1.2-.682-2.133-.886-2.769l-.227-.723c-.049-.163-.072-.25-.072-.25s.03.076.083.235l.239.708c.208.633.515,1.553.909,2.742.788,2.4,1.924,5.863,3.341,10.166,2.822,8.64,6.742,20.639,11.136,34.09l.042.129H251.9l-.027-.064c-.208-.553-.424-1.11-.636-1.67-7.784-20.484-14.507-38.173-17.609-46.332v-.057h.061l4.121.023h1.049C239.073,351.751,239.183,351.758,239.183,351.758Z",
    transform: "translate(-192.711 -300.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M141.537,351.87,125.92,399.853h2.841l18.3-47.983Z",
    transform: "translate(-125.799 -300.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M141.338,351.833h1.4l4.121-.023h.061l-.023.057c-3.1,8.159-9.822,25.847-17.605,46.332l-.64,1.67-.023.064H125.6l.042-.129,11.14-34.09,3.341-10.166c.379-1.189.7-2.11.909-2.742l.239-.708c.053-.159.083-.235.083-.235s-.023.087-.072.25l-.227.723c-.2.636-.5,1.568-.886,2.769-.776,2.405-1.894,5.882-3.288,10.2-2.8,8.628-6.689,20.617-11.049,34.067l-.095-.129h2.841l-.091.061.636-1.67c7.833-20.454,14.594-38.139,17.711-46.29l.042.057-4.1-.023h-1.057Z",
    transform: "translate(-125.6 -300.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.712,354.65a2.141,2.141,0,0,1-.273.2l-.8.53-2.958,1.939c-2.5,1.644-5.939,3.924-9.723,6.462l-9.689,6.534-2.939,1.973-.8.508a1.775,1.775,0,0,1-.288.174,2.347,2.347,0,0,1,.265-.2l.78-.557,2.905-2.023c2.458-1.7,5.871-4.026,9.659-6.564s7.238-4.8,9.757-6.416c1.258-.8,2.273-1.451,2.992-1.894l.822-.5A2.19,2.19,0,0,1,189.712,354.65Z",
    transform: "translate(-148.362 -302.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.984,216.753s-4.894.5-5.606,3.451-3.03,39.392,0,44.555,42.044,4.443,44.752,3.735,3.985-2.466,3.708-4.613-26.844-4.81-26.844-4.81l1.621-38.036S152.063,216.223,143.984,216.753Z",
    transform: "translate(-132.594 -216.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M193.869,337.905H193.4l-1.337.034c-1.163.03-2.845.045-4.924.042-4.166,0-9.9-.144-16.234-.6-3.163-.231-6.174-.523-8.9-.833s-5.185-.651-7.238-.973c-1.03-.151-1.954-.314-2.769-.451s-1.515-.261-2.087-.379l-1.314-.254-.341-.068-.114-.03a.454.454,0,0,1,.117,0l.345.049,1.322.216c.572.1,1.273.216,2.091.337s1.742.28,2.769.42c2.057.307,4.511.621,7.238.932s5.738.587,8.9.818c6.326.455,12.064.61,16.219.655,2.076.023,3.757.027,4.924.023h1.689Z",
    transform: "translate(-139.602 -289.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M208.655,372.374c-.03.045-6.212-4.3-13.8-9.7s-13.723-9.818-13.693-9.848,6.212,4.3,13.806,9.7S208.685,372.329,208.655,372.374Z",
    transform: "translate(-160.115 -301.272)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.324 2.968)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M246.345,302s8.765,0,9.125,8.166-25.514,51.248-25.514,51.248l-8.193-3.89,17.568-41.805-38.12-3.75,1.079-9.591Z",
    transform: "translate(-182.529 -208.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M261.493,445.249l-.254.58s8.03,8.257,7.31,10.159l-19.359-8.712,3.163-6.326A12.121,12.121,0,0,0,261.493,445.249Z",
    transform: "translate(-212.335 -294.989)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(40.086 148.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M258.686,448.718a.871.871,0,0,0-.954.655.833.833,0,0,0,.644.951.917.917,0,0,0,1-.7.86.86,0,0,0-.776-.913",
    transform: "translate(-257.72 -448.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(36.855 150.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M249.19,455.175l.758-1.515,18.276,8.9s.693.758.322,1.326Z",
    transform: "translate(-249.19 -453.66)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M277.425,453.461c-.045.091-.538-.076-1.136.019s-1.03.379-1.1.3.318-.561,1.049-.663S277.485,453.382,277.425,453.461Z",
    transform: "translate(-228.48 -302.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M282.362,458.428c-.019.1-.5.076-1,.333s-.784.636-.875.591.087-.61.716-.917S282.4,458.337,282.362,458.428Z",
    transform: "translate(-231.762 -305.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.586,464.284c-.095,0,0-.549.458-.958s1.011-.413,1.015-.318-.379.25-.758.591S285.684,464.318,285.586,464.284Z",
    transform: "translate(-234.925 -308.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M263.6,220.71l1.557,4.761-8.488.663-.989-2.549Z",
    transform: "translate(-216.367 -158.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M339.787,237.2c.163.326.587.379.913.549a1.867,1.867,0,0,1,.936,1.742,4.136,4.136,0,0,1-.67,1.954,1.693,1.693,0,0,1-.5.6.644.644,0,0,1-.735,0c-.25-.208-.22-.595-.167-.917.2-1.208-.061-2.735.223-3.928",
    transform: "translate(-268.453 -168.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M191.148,65.79a2.144,2.144,0,0,1,1.651-2.379l9.371-5.962c3.572-.8,8.072,5.163,8.712,8.761a60.729,60.729,0,0,1,.758,11.969c-.258,6.159-4.3,6.818-4.3,6.818l3.03,20.48-14.6-9Z",
    transform: "translate(-176.266 -56.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M235.608,93.175a.78.78,0,0,1-.655.867.758.758,0,0,1-.883-.606.78.78,0,0,1,.655-.867A.758.758,0,0,1,235.608,93.175Z",
    transform: "translate(-202.939 -78.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M236.53,88.194c-.076.083-.7.072-1.481.379s-1.3.716-1.4.693,0-.133.239-.322a3.7,3.7,0,0,1,1.1-.621,3.348,3.348,0,0,1,1.2-.223C236.458,88.091,236.568,88.156,236.53,88.194Z",
    transform: "translate(-202.657 -75.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M215.127,94.165a.784.784,0,0,1-.659.867.758.758,0,0,1-.879-.606.776.776,0,0,1,.655-.867A.758.758,0,0,1,215.127,94.165Z",
    transform: "translate(-190.215 -79.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.356,91.28c-.114.045-.7-.3-1.6-.436s-1.614,0-1.7-.061.087-.125.379-.2a3.92,3.92,0,0,1,1.379-.027,3.553,3.553,0,0,1,1.261.424C214.341,91.14,214.428,91.261,214.356,91.28Z",
    transform: "translate(-188.63 -77.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.624,94.807a5.417,5.417,0,0,1,1.326-.405c.208-.045.405-.11.424-.261a1.072,1.072,0,0,0-.216-.614q-.379-.758-.818-1.549a25.892,25.892,0,0,1-1.894-4.079,26.2,26.2,0,0,1,2.235,3.917l.792,1.561a1.242,1.242,0,0,1,.208.826.542.542,0,0,1-.314.352,1.492,1.492,0,0,1-.356.091,5.6,5.6,0,0,1-1.386.163Z",
    transform: "translate(-198.2 -75.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M220.263,128.476a15.094,15.094,0,0,1-8.333-1.136s2.489,4.257,8.473,2.985Z",
    transform: "translate(-189.188 -100.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M225.461,110.095a2.239,2.239,0,0,0-1.723-.875.954.954,0,0,0-.879.633,1.515,1.515,0,0,0,.292,1.371,1.288,1.288,0,0,0,1.333.466,2.121,2.121,0,0,0,.966-.8.758.758,0,0,0,.178-.322.527.527,0,0,0-.114-.432",
    transform: "translate(-195.943 -88.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M223.111,108.419c.136-.027.242.879,1.091,1.432s1.8.341,1.826.466c0,.057-.193.2-.6.261a2.273,2.273,0,0,1-1.515-.337,1.977,1.977,0,0,1-.856-1.212C222.974,108.639,223.05,108.419,223.111,108.419Z",
    transform: "translate(-196.078 -88.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.244,81.7c-.08.227-.92.133-1.894.269s-1.776.413-1.913.212c-.061-.1.076-.314.379-.542a3.341,3.341,0,0,1,2.905-.379C214.092,81.435,214.278,81.594,214.244,81.7Z",
    transform: "translate(-188.252 -71.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M235.616,82.3c-.163.208-.9.095-1.758.182s-1.572.307-1.761.125c-.087-.087,0-.292.307-.5a3.068,3.068,0,0,1,2.833-.25C235.563,82.017,235.685,82.2,235.616,82.3Z",
    transform: "translate(-201.697 -71.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.8,80.509c.151-2.746.591-11.537,2.364-16.333s4.269-6.943,6.837-7.954a6.129,6.129,0,0,1,5.985.659c1.318.932,2.083,4,2.083,4s-6.231,2.151-7.954,6.06a31.135,31.135,0,0,0-2.352,6.644l-.538,2.382s1.17,10.356,1.7,12.5l-8.447,8.166C179.746,93.936,179.644,83.251,179.8,80.509Z",
    transform: "translate(-169.023 -55.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.713,61.093a4.933,4.933,0,0,1,5.432,3.159c.826,1.8,1.644,7.246,1.644,7.246a35.186,35.186,0,0,0-.17-6.871,11.971,11.971,0,0,0-4.117-6.871c-2.068-1.5-3.636-2.061-6.871-1.492a5.276,5.276,0,0,1,2.549,1.489C218.668,58.325,218.91,58.832,219.713,61.093Z",
    transform: "translate(-191.487 -55.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M192.82,101.04a1.844,1.844,0,0,0-2.864-1.254,2.532,2.532,0,0,0-.776,2.651c.591,3.788,4.254,2.4,4.242,2.3S193.078,102.6,192.82,101.04Z",
    transform: "translate(-175.018 -82.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M193.654,105.366a1.134,1.134,0,0,1-.159.125.689.689,0,0,1-.492.087,1.648,1.648,0,0,1-.977-1.341,2.174,2.174,0,0,1,.038-.97.758.758,0,0,1,.413-.583.345.345,0,0,1,.417.121c.068.1.053.174.076.178s.072-.076,0-.227a.417.417,0,0,0-.186-.212.5.5,0,0,0-.379-.038.943.943,0,0,0-.6.693,2.238,2.238,0,0,0-.061,1.083,1.72,1.72,0,0,0,1.212,1.481.712.712,0,0,0,.583-.193C193.661,105.457,193.669,105.37,193.654,105.366Z",
    transform: "translate(-176.624 -84.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M208.55,55.725c0,.03.523-.045,1.356-.03a4.685,4.685,0,0,1,1.432.254,4.614,4.614,0,0,1,1.515.924,7.076,7.076,0,0,1,1.856,2.651c.311.758.379,1.3.424,1.288a1.8,1.8,0,0,0-.053-.36,6.788,6.788,0,0,0-2.136-3.667,4.6,4.6,0,0,0-1.572-.955,4.477,4.477,0,0,0-1.47-.231,7.747,7.747,0,0,0-1,.064A2.156,2.156,0,0,0,208.55,55.725Z",
    transform: "translate(-187.089 -55.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M189.453,82.954a.485.485,0,0,0,0-.064l-.053-.17c-.027-.08-.053-.174-.087-.28l-.1-.379a8.932,8.932,0,0,1-.258-2.534,9.121,9.121,0,0,1,.913-3.644,10.287,10.287,0,0,1,2.954-3.511,19.566,19.566,0,0,1,1.989-1.348c.667-.4,1.337-.735,1.958-1.106a24.644,24.644,0,0,0,3.091-2.231c.83-.7,1.47-1.3,1.894-1.727.216-.212.379-.379.489-.5l.125-.133c.027-.03.042-.045.038-.049l-.045.038-.136.125-.5.489c-.443.413-1.091,1-1.928,1.689a25.688,25.688,0,0,1-3.091,2.2c-.614.379-1.292.693-1.962,1.1a18.652,18.652,0,0,0-2,1.356,10.329,10.329,0,0,0-3,3.557,9.06,9.06,0,0,0-.894,3.693,8.754,8.754,0,0,0,.3,2.549l.114.379c.042.106.076.2.1.277l.068.17C189.442,82.935,189.449,82.954,189.453,82.954Z",
    transform: "translate(-174.844 -61.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M187.227,78v-.061l-.023-.182c0-.159-.061-.379-.091-.693a14.612,14.612,0,0,1-.042-2.568,14.864,14.864,0,0,1,.758-3.72,14.329,14.329,0,0,1,2.216-4.072,16.828,16.828,0,0,1,3.409-3.182c1.136-.848,2.273-1.515,3.178-2.114s1.659-1.057,2.163-1.405c.254-.167.443-.307.572-.4l.148-.106.049-.042a.1.1,0,0,0-.057.03l-.155.095-.587.379c-.508.33-1.258.8-2.186,1.364s-2.034,1.25-3.2,2.1a16.591,16.591,0,0,0-3.409,3.193,14.269,14.269,0,0,0-2.254,4.121,14.714,14.714,0,0,0-.758,3.757,13.58,13.58,0,0,0,.087,2.576c.038.3.091.534.117.693a.66.66,0,0,0,.038.178C187.212,77.99,187.223,78,187.227,78Z",
    transform: "translate(-173.66 -57.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M241.1,146.93s4.882,1.985,5.818,4.526,8.034,23.529,8.034,23.529l-8.238,3.159-3.757-17.272Z",
    transform: "translate(-207.31 -112.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M174.445,301.554s50.377-2.314,53.54-1.481,5.053,2.428,5.682,6.219,10.341,54.025,10.341,54.025l-8.833,2.6s-12.393-28.294-12.92-33.029-2.273-14.439-2.273-14.439-19.151.314-33.253,0-12.208-13.367-12.208-13.367Z",
    transform: "translate(-165.896 -207.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M234.712,362.853l-.064-.152c-.508-1.159-12.409-28.374-12.931-33.086-.485-4.345-2.011-12.992-2.239-14.268-1.894.03-19.836.3-33.1,0-4.382-.1-7.682-1.428-9.814-3.947-3.227-3.814-2.651-9.155-2.579-9.606l-.117-.708h.212c2.061-.095,50.449-2.307,53.6-1.473,3.538.936,5.223,2.78,5.822,6.367.621,3.742,10.227,53.521,10.341,54.025l.03.167Zm-14.92-47.888.03.159c.019.095,1.75,9.765,2.273,14.45.5,4.473,11.852,30.571,12.837,32.821l8.511-2.5c-.621-3.216-9.7-50.225-10.31-53.862-.568-3.409-2.174-5.174-5.545-6.06-2.985-.792-49.7,1.314-53.271,1.477l.057.345v.027c0,.057-.758,5.507,2.492,9.341,2.061,2.432,5.265,3.712,9.53,3.81,13.935.311,33.052,0,33.245,0Z",
    transform: "translate(-165.545 -207.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M175.423,176.031l1.269,7.848s-5.511,10.443-6.132,19.42c-.3,4.265,2.151,13,2.151,13s19.408,2.132,29.878,1.86l11.17-.489,1.97-17.45-12.537-1.811.189-23.779s2.273-6.261,2.447-8.113a16.223,16.223,0,0,0-3.67-12.931l-4.894-9.984-1.633-.758.776,12.094L182.339,141.57l-7.125,2.557-2.019,9.526Z",
    transform: "translate(-163.473 -109.007)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(26.739 87.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.08,291.089c-.913.159-7.5.254-8.413.413a1.2,1.2,0,0,1-.939-.1.784.784,0,0,1-.189-.86,1.974,1.974,0,0,1,.553-.758,18.426,18.426,0,0,1,5.682-3.246,3.311,3.311,0,0,1,2.015-.379,2.144,2.144,0,0,1,1.386,1.439,6.249,6.249,0,0,1,.235,2.057",
    transform: "translate(-222.483 -286.107)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(11.559 51.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.317,213.127c2.352-.549,3.829-2.867,4.784-5.087s1.742-4.67,3.613-6.2c1.371-1.136,3.208-1.636,4.394-2.954a4.64,4.64,0,0,0,.807-4.788,2.414,2.414,0,0,0-1.894-1.621c-1.023-.053-1.818.833-2.443,1.648q-4.288,5.617-8.087,11.59c-1.36,2.14-2.716,4.738-1.769,7.091",
    transform: "translate(-182.406 -192.474)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M166.069,151.62s-3.981,1.265-5.42,3.761-3.826,14.617-4.4,17.882-3.36,16.7,0,18.814,7.776-1.136,8.928-3.072,5.852-12,5.852-12l-4.223-3.549s.758-9.6.481-11.617S166.069,151.62,166.069,151.62Z",
    transform: "translate(-153.585 -115.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M151.89,172.992l9.238.6,4.22-4.954,1.167-7.8L166.2,145.91s-8.246,2.011-10.03,8.28C154.852,158.822,151.89,172.992,151.89,172.992Z",
    transform: "translate(-151.89 -111.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.309,170.791c-.53-.072-1.208.553-.758,2.061.379,1.258,1.091,2.481,1.038,3.182s-.326,2.159-.326,2.917a21.073,21.073,0,0,1-.216,2.212l-6.288,7.575,5.443,4.8,4.307-6.765a2.427,2.427,0,0,0,2.053-.648l1.136-1.3s2.917-1.08,2.322-2.651a1.689,1.689,0,0,0,.08-2.14,2.894,2.894,0,0,0-.186-2.178s-.053-1.837-.542-2.163-5.541-.379-5.541-.379a26.329,26.329,0,0,0-.951-2.473C185.328,171.931,185.048,170.889,184.309,170.791Z",
    transform: "translate(-167.961 -127.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M200,187.245c0,.019-.133-.053-.25-.231a1.254,1.254,0,0,1,.167-1.557c.152-.148.28-.193.292-.174a2.159,2.159,0,0,0-.451.943,2.273,2.273,0,0,0,.242,1.019Z",
    transform: "translate(-181.498 -136.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M209.488,189.1a10.927,10.927,0,0,1-2.337.413,10.723,10.723,0,0,1-2.371.08,21.389,21.389,0,0,1,2.352-.276A20.641,20.641,0,0,1,209.488,189.1Z",
    transform: "translate(-184.747 -138.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M211.855,194.8a6.708,6.708,0,0,1-1.966.47,6.792,6.792,0,0,1-2.019.068c0-.057.894-.114,1.992-.265S211.843,194.751,211.855,194.8Z",
    transform: "translate(-186.666 -142.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M213.13,200.688a7.7,7.7,0,0,1-3.03.3,8.634,8.634,0,0,1,1.515-.193A8.736,8.736,0,0,1,213.13,200.688Z",
    transform: "translate(-188.052 -145.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M204.53,200.318c0,.023-.106,0-.235-.072a.807.807,0,0,1-.333-.492.822.822,0,0,1,.076-.587c.076-.133.159-.186.178-.17a1.422,1.422,0,0,0-.064.712C204.242,200.091,204.556,200.269,204.53,200.318Z",
    transform: "translate(-184.223 -144.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M201.408,194.559c0,.019-.125-.045-.242-.208a1.39,1.39,0,0,1-.25-.731,1.425,1.425,0,0,1,.167-.758c.1-.174.2-.25.22-.235a3.072,3.072,0,0,0-.189.977A3.228,3.228,0,0,0,201.408,194.559Z",
    transform: "translate(-182.345 -140.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M211.031,206.961a2.273,2.273,0,0,1-.886.258,2.216,2.216,0,0,1-.924.064,2.213,2.213,0,0,1,.886-.258A2.144,2.144,0,0,1,211.031,206.961Z",
    transform: "translate(-187.505 -149.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M201.948,182.681c0,.057-.758.057-1.716.152s-1.7.242-1.712.189a4.83,4.83,0,0,1,1.693-.379A4.925,4.925,0,0,1,201.948,182.681Z",
    transform: "translate(-180.858 -134.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M248.076,230.91h31.309a2.083,2.083,0,0,1,2.083,2.083v22.192H246v-22.2A2.083,2.083,0,0,1,248.076,230.91Z",
    transform: "translate(-210.354 -164.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M271.305,296.638H229.64a1.6,1.6,0,0,1,1.6-1.6h40.067Z",
    transform: "translate(-200.19 -204.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 33.082,
    height: 22.73,
    transform: "translate(36.722 67.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M281.831,257.565v-1.621c0-1.057,0-2.6-.023-4.579,0-3.954-.023-9.625-.042-16.53l.08.08H248.768l.1-.1v22.726l-.087-.091,23.829.045,6.818.027h.038l-6.784.023-23.889.045H248.7V234.74h33.256v.1c0,6.924-.03,12.613-.042,16.579v5.735A.864.864,0,0,1,281.831,257.565Z",
    transform: "translate(-212.031 -166.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.659,294.838c0,.057-8.943.1-19.973.1s-19.977-.042-19.977-.1,8.943-.1,19.977-.1S273.659,294.8,273.659,294.838Z",
    transform: "translate(-202.719 -204.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 8.693,
    cy: 8.693,
    r: 8.693,
    transform: "translate(44.566 70.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M278.24,258.86l1.841-1.742,2.542,2.341,5-4.708,1.818,1.72-6.848,6.5Z",
    transform: "translate(-230.382 -179.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M175.009,198.18c.042.034-2.568,3.185-5.829,7.034s-5.939,6.939-5.981,6.913,2.568-3.182,5.829-7.034S174.968,198.145,175.009,198.18Z",
    transform: "translate(-158.915 -144.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.395,185.29a27.764,27.764,0,0,1-.451,3.273,27.391,27.391,0,0,1-.644,3.242,27.769,27.769,0,0,1,.451-3.276A28.365,28.365,0,0,1,191.395,185.29Z",
    transform: "translate(-175.751 -136.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.529,193.384a1.348,1.348,0,0,1,.061-.227l.2-.636c.182-.549.451-1.345.758-2.333a34.89,34.89,0,0,0,.917-3.515,19.146,19.146,0,0,0,.405-4.409,17.541,17.541,0,0,0-2.212-7.678,22.691,22.691,0,0,0-1.288-2.083c-.159-.239-.3-.417-.379-.542a1.1,1.1,0,0,1-.125-.2,1.091,1.091,0,0,1,.155.174c.1.121.246.292.417.526a19.49,19.49,0,0,1,1.348,2.057,18.473,18.473,0,0,1,1.481,3.341,16.064,16.064,0,0,1,.814,4.4,18.617,18.617,0,0,1-.424,4.454,32.7,32.7,0,0,1-.962,3.519c-.326.985-.614,1.776-.818,2.318q-.148.379-.239.625A.988.988,0,0,1,254.529,193.384Z",
    transform: "translate(-214.621 -127.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M223.718,197.71a3.029,3.029,0,0,1,0,.53,4.426,4.426,0,0,1-.045.621,7.889,7.889,0,0,1-.125.818,8.05,8.05,0,0,1-.242.97,10.74,10.74,0,0,1-.379,1.087,12.272,12.272,0,0,1-1.3,2.273,11.972,11.972,0,0,1-1.792,1.932,10.115,10.115,0,0,1-.917.7,7.8,7.8,0,0,1-.852.527,7.009,7.009,0,0,1-.758.379,4.331,4.331,0,0,1-.576.231,2.839,2.839,0,0,1-.508.155c-.019-.042.708-.265,1.754-.875a9.206,9.206,0,0,0,.83-.538c.3-.2.58-.447.89-.7a11.78,11.78,0,0,0,3.03-4.167,10.9,10.9,0,0,0,.379-1.061,8.94,8.94,0,0,0,.261-.954A15.145,15.145,0,0,0,223.718,197.71Z",
    transform: "translate(-191.859 -143.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M225.129,166.588a.269.269,0,0,1-.053-.072l-.133-.231c-.125-.208-.3-.492-.511-.845s-.553-.784-.905-1.276-.8-1.03-1.273-1.633c-1.947-2.379-4.822-5.5-8.117-8.841s-6.39-6.246-8.659-8.333l-1.545-1.383c-.455-.4-.848-.758-1.178-1.03L202,142.3l-.193-.17a.273.273,0,0,1-.064-.064.379.379,0,0,1,.076.049c.057.042.125.091.2.155l.78.61,1.2,1.008c.466.4.989.86,1.564,1.364,2.3,2.045,5.4,4.951,8.712,8.284a117.912,117.912,0,0,1,8.083,8.89c.47.61.894,1.159,1.258,1.651l.879,1.3c.2.379.379.652.481.867l.121.227Q225.137,166.588,225.129,166.588Z",
    transform: "translate(-182.858 -109.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M209.039,252.608a.757.757,0,0,1-.216.042l-.617.087c-.538.072-1.322.155-2.273.242-1.936.174-4.621.314-7.575.28s-5.651-.25-7.575-.47c-.966-.11-1.746-.216-2.273-.3l-.617-.1a.916.916,0,0,1-.212-.049.879.879,0,0,1,.22,0l.621.064c.538.064,1.322.148,2.273.239,1.928.186,4.606.379,7.575.413s5.64-.087,7.575-.223c.966-.068,1.75-.129,2.273-.178l.621-.049a.966.966,0,0,1,.2,0Z",
    transform: "translate(-174.124 -177.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M287.38,225.541s6.2-2.42,6.791-2.614,6.011-.617,6.011-.617l6.992,2.511s.064,1.436-1.568,1.242a29.547,29.547,0,0,1-4.246-1.045l-.981.583Z",
    transform: "translate(-236.06 -159.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M338.3,233.264c.163.33.587.379.913.553a1.894,1.894,0,0,1,.936,1.742,4.121,4.121,0,0,1-.67,1.951,1.708,1.708,0,0,1-.5.6.644.644,0,0,1-.735,0,.958.958,0,0,1-.167-.917c.2-1.208-.061-2.739.223-3.932",
    transform: "translate(-267.522 -165.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M341.587,454.47l.212.591s11.515.451,12.3,2.322l-20.03,7.038L332,457.659A12.151,12.151,0,0,0,341.587,454.47Z",
    transform: "translate(-263.779 -303.388)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(70.646 155.563)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M338.758,466.425a.871.871,0,0,0-.239,1.136.837.837,0,0,0,1.136.246.913.913,0,0,0,.246-1.2.867.867,0,0,0-1.193-.125",
    transform: "translate(-338.403 -466.3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(69.797 153.256)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M336.656,467.986l-.5-1.625,19.378-6.151s1.026.076,1.136.758Z",
    transform: "translate(-336.16 -460.21)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.7,456.065c.03.1-.443.314-.814.8s-.481.985-.583.977-.159-.625.3-1.2S355.69,455.967,355.7,456.065Z",
    transform: "translate(-277.59 -304.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.924,456.43c.057.087-.311.4-.5.932s-.129,1-.227,1.034-.356-.5-.11-1.159S362.889,456.339,362.924,456.43Z",
    transform: "translate(-282.408 -304.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.4,458.8c-.079.053-.379-.379-.326-1.011s.447-1,.515-.932-.11.455-.155.966S369.49,458.756,369.4,458.8Z",
    transform: "translate(-286.804 -304.867)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.195 275.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M50.315,358.529s-9.274-10.674-12.773-21.348-1.839-9.449-1.839-9.449,4.725,10.369,8.312,15.378,9.976,12.356,9.976,12.356Z",
    transform: "translate(-35.309 -317.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M81.452,332.035a.541.541,0,0,0-1,.351c.565,3.752,1.787,12.549,1.755,18.253-.06,7.413,0,10.278,0,10.278h3.861s-.7-15.325-1.558-20.008A32.532,32.532,0,0,0,81.452,332.035Z",
    transform: "translate(-64.599 -319.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M89.32,357.221A40.876,40.876,0,0,0,92.5,345.7c.316-2.727-.249-6.416-1.092-11.338a30.266,30.266,0,0,1-.488-5.455.92.92,0,0,1,1.727-.432,24.545,24.545,0,0,1,2.159,5.451c.934,4.858,1.99,7.287,1.183,11.9s-3.8,11.71-3.8,11.71Z",
    transform: "translate(-70.362 -317.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M99.22,346.609S109.4,324.727,110.1,321.48s3.106-10.727,3.387-10.3.7,4.374-1.127,8.891-9.67,27.207-9.67,27.207H99.22",
    transform: "translate(-76.787 -306.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.4,356.876a1.815,1.815,0,0,1-.284-.2c-.183-.137-.456-.33-.79-.6-.677-.534-1.629-1.344-2.738-2.415a45.983,45.983,0,0,1-7.371-9.477,62.194,62.194,0,0,1-5.044-10.923c-.512-1.453-.885-2.643-1.127-3.468-.126-.414-.211-.737-.27-.955a2.05,2.05,0,0,1-.081-.351,2.011,2.011,0,0,1,.123.323c.077.235.179.551.309.944.267.818.663,2,1.19,3.443a66.364,66.364,0,0,0,5.086,10.864,48.087,48.087,0,0,0,7.308,9.477c1.092,1.085,2.022,1.91,2.682,2.457.326.281.593.484.762.632a2.142,2.142,0,0,1,.246.246Z",
    transform: "translate(-35.563 -317.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.492,349.415a3.08,3.08,0,0,1-.091-.642c-.049-.453-.112-1.053-.19-1.755-.161-1.481-.414-3.51-.772-5.767s-.762-4.261-1.074-5.714c-.151-.7-.274-1.281-.372-1.727a3.568,3.568,0,0,1-.112-.639,3.762,3.762,0,0,1,.2.618c.112.4.263.986.439,1.713.351,1.45.776,3.468,1.137,5.718s.59,4.3.7,5.785c.06.741.1,1.344.119,1.755A3.951,3.951,0,0,1,84.492,349.415Z",
    transform: "translate(-65.533 -320.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.208,328.87a1.359,1.359,0,0,1,.119.277l.305.814c.137.351.291.786.439,1.3s.351,1.092.495,1.755l.253,1.028c.084.351.144.737.221,1.127.168.776.27,1.618.393,2.5a37.205,37.205,0,0,1-.414,11.569c-.186.871-.351,1.706-.569,2.457-.109.383-.2.758-.305,1.109l-.326,1.025c-.193.646-.432,1.211-.618,1.713a11.2,11.2,0,0,1-.53,1.267l-.351.79a1.383,1.383,0,0,1-.14.267,1.6,1.6,0,0,1,.1-.284c.084-.2.193-.47.326-.8s.319-.772.491-1.281.4-1.053.59-1.716c.1-.319.2-.656.309-1.007s.19-.723.291-1.106c.211-.762.351-1.59.548-2.457a38.576,38.576,0,0,0,.414-11.506c-.119-.881-.214-1.72-.372-2.5-.074-.386-.13-.765-.211-1.123s-.161-.7-.239-1.028c-.137-.656-.323-1.236-.46-1.755s-.281-.955-.4-1.313l-.263-.825a1.6,1.6,0,0,1-.091-.3Z",
    transform: "translate(-72.867 -318.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M116.462,312.46a.419.419,0,0,1,0,.1,2.439,2.439,0,0,1-.046.284c-.046.249-.1.618-.2,1.088a39.537,39.537,0,0,1-1.053,3.938c-.527,1.643-1.2,3.573-2.025,5.69s-1.776,4.426-2.682,6.883-1.625,4.847-2.289,7.02-1.285,4.124-1.888,5.735a36.4,36.4,0,0,1-1.6,3.745c-.207.432-.4.755-.516.979l-.144.249c-.032.056-.049.084-.053.081a.294.294,0,0,1,.035-.091l.123-.26c.109-.228.284-.558.481-1,.407-.867.962-2.141,1.537-3.759s1.193-3.563,1.839-5.739,1.358-4.563,2.278-7.02,1.867-4.77,2.7-6.883,1.541-4.026,2.067-5.662.874-2.977,1.1-3.91c.112-.467.183-.832.242-1.081.025-.112.049-.2.067-.277A.319.319,0,0,1,116.462,312.46Z",
    transform: "translate(-79.869 -307.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M47.366,298.231a.874.874,0,0,0-1.443.892,24.974,24.974,0,0,0,1.278,3.292c1.4,2.973,5.511,13.647,7.438,19.509s4.623,16.8,4.623,16.8l4.11-.667s-3.759-17.954-7.42-24.444C53,308.411,50.044,300.892,47.366,298.231Z",
    transform: "translate(-42.171 -297.983)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74,376.64a2.3,2.3,0,0,1,.214.491c.119.323.288.793.474,1.379.379,1.172.842,2.808,1.306,4.63s.856,3.478,1.127,4.679c.123.565.225,1.053.309,1.422a2.713,2.713,0,0,1,.084.53,2.63,2.63,0,0,1-.168-.509c-.1-.376-.225-.846-.376-1.4-.316-1.236-.727-2.861-1.186-4.658s-.9-3.461-1.243-4.64c-.161-.558-.3-1.025-.407-1.4A2.678,2.678,0,0,1,74,376.64Z",
    transform: "translate(-60.419 -349.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.215,338.719a.436.436,0,0,1-.021-.109,2.433,2.433,0,0,0-.049-.323c-.042-.284-.081-.7-.168-1.246-.151-1.081-.418-2.636-.86-4.535a65.441,65.441,0,0,0-1.924-6.564c-.846-2.436-1.9-5.069-3.1-7.792-2.418-5.437-4.833-10.264-6.423-13.83-.8-1.783-1.4-3.233-1.832-4.247-.207-.505-.351-.9-.46-1.169-.049-.123-.084-.225-.116-.305a.4.4,0,0,1-.032-.109.473.473,0,0,1,.053.1l.133.3c.123.281.288.667.5,1.155.432,1,1.074,2.457,1.892,4.212,1.622,3.542,4.061,8.361,6.483,13.809,1.2,2.727,2.253,5.367,3.089,7.813a62.127,62.127,0,0,1,1.885,6.6,45.709,45.709,0,0,1,.793,4.563c.074.541.1.965.13,1.25l.025.326a.457.457,0,0,1,0,.105Z",
    transform: "translate(-43.046 -298.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.43,380.22a4.51,4.51,0,0,1-.14-.7c-.081-.481-.19-1.12-.319-1.888-.281-1.594-.7-3.787-1.337-6.174s-1.309-4.5-1.843-6.03c-.26-.737-.477-1.344-.642-1.8a4.355,4.355,0,0,1-.218-.67,4.213,4.213,0,0,1,.3.639c.176.418.425,1.025.7,1.783a59.674,59.674,0,0,1,1.909,6.041,62.622,62.622,0,0,1,1.281,6.2c.116.8.2,1.45.249,1.9A4.685,4.685,0,0,1,87.43,380.22Z",
    transform: "translate(-66.215 -340.146)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16.045,
    height: 19.548,
    transform: "translate(13.609 39.484)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(13.609 39.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 16.045,
    height: 19.548,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 14.233,
    height: 19.548,
    transform: "translate(10.299 39.484)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSucess);
export default __webpack_public_path__ + "static/media/illustration-sucess.fbd27d70c2016e313e585ffe4c260103.svg";
export { ForwardRef as ReactComponent };